<template>
  <v-dialog
    v-model="dialog"
    persistent
    scrollable
    max-width="1200px"
  >
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Dữ liệu {{ this.item.label }}
        </v-toolbar-title>
        <v-spacer/>
        <v-menu
          bottom
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-menu>
      </v-toolbar>
      <v-card-text class="mt-4">
        <v-data-table
          :page.sync="page"
          :pageCount="numberOfPages"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          :headers="headers"
          :items="items"
          loading-text="Đang tải dữ liệu... Vui lòng chờ"
          :items-per-page="10"
          :footer-props="{
            showFirstLastPage: true
          }"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template v-slot:item.more="{ item }">
            <span>...</span>
          </template>
          <template v-slot:item.thang_1="{ item }">
            {{ item.thang_1 | currency }}
          </template>
          <template v-slot:item.thang_2="{ item }">
            {{ item.thang_2 | currency }}
          </template>
          <template v-slot:item.muc_tang="{ item }">
            {{ item.muc_tang | currency }}
          </template>
          <template v-slot:item.phan_tram_tang="{ item }">
            <span v-if="item.thang_1==item.thang_2">0%</span>
            <span v-else>
              {{ ((item.thang_2/item.thang_1)*100).toFixed(2) }}%
            </span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          color="green darken-1"
          dark
          @click="exportData"
        >
          Tải về
          <v-icon right>
            mdi-microsoft-excel
          </v-icon>
        </v-btn>
        <v-btn
          color="pink darken-1"
          dark
          @click="close"
        >
          Đóng lại
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { mapActions } from 'vuex';
  import FileSevice from '@/services/File';
  export default {
    props: {
      showDialog: {
        type: Boolean,
        default: false
      },
      item: {
        type: Object
      }
    },
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        headers: [],
        items: [],
        page: 1,
        totalItems: 0,
        numberOfPages: 0,
        options: {},
        sortDesc: true,
        sortBy: "thang",
      }
    },
    mounted() {
      this.dialog = this.showDialog;
    },
    watch: {
      showDialog() {
        this.dialog = false;
        if (this.showDialog) {
          this.dialog = true;
        }
      },
      options: {
        handler() {
          this.getDatas();
        }
      },
      "item": function() {
        this.getDatas();
        this.page = 1;
      }
    },
    methods: {
      ...mapActions([
        'openSnackbar'
      ]),
      getDatas() {
        const app = this;
        const { page, itemsPerPage, sortBy, sortDesc } = app.options;
        let pageNumber = page;
        let request = {
          params: {
            size: itemsPerPage ? itemsPerPage : 10,
            page: pageNumber ? pageNumber : 1,
            sortDesc: sortDesc && sortDesc[0] ? 'desc' : 'asc',
            sortBy: sortBy && sortBy[0] ? sortBy[0] : 'thang'
          }
        };
        app.loading = true;
        axios.get(`api/v1/fake-data-list/${app.item.key}`, request)
          .then(response => {
            app.headers = response.data.header;
            app.items = response.data.result.data;
            app.totalItems = response.data.result.total;
            app.numberOfPages = response.data.result.to;
            app.loading = false;
          })
          .catch(function (error) {
            app.openSnackbar({ type: 'error' });
          });
      },
      close() {
        this.dialog = false;
        this.$emit('cancelled');
      },
      exportData() {
        const app =this;
        app.loading=true;
        axios.get(
          `api/v1/fake-data-export-tmp/${app.item.key}`,
          {responseType: 'arraybuffer'}
        )
          .then(function (response) {
            let ext = app.item.key == 'foodSafe' ? '.xls' : '.xlsx';
            let fileName = app.item.key + Date.now() + ext;
            FileSevice.download(response.data, fileName);
            app.loading=false;
            app.openSnackbar({ 
              type: 'success',
              body: 'Tải về thành công!'
            });
          })
          .catch(function (error) {
            app.loading=false;
            app.openSnackbar({ type: 'error' });
          });
      }
    }
  }
</script>